import { type RtkQueryLayers } from '../../core';
import { callRatingOGService } from './callRating.og';

export const callRatingRTKQueryLayers: RtkQueryLayers = {
  reducers: {
    callRatingOGReducerFromLibrary: callRatingOGService.reducer,
  },
  middlewares: [callRatingOGService.middleware],
};
